import React from "react";
import PropTypes from "prop-types";
import { tokens } from "../../theme";

export const MapSelectionDialogModal = ({
  showMapSelectionModalDialog,
  closeMapSelectionDialogModal,
  navigateToMapSettingsScreen,
}) => {
  const handleSettingsClick = async () => {
    try {
      if (navigateToMapSettingsScreen) navigateToMapSettingsScreen();
    } catch (error) {
      console.error("Failed to process settings navigation", error);
    }
  };

  if (!showMapSelectionModalDialog) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        <h2 style={styles.titleText}>No Map Selected</h2>
        <p style={styles.messageText}>
          Please select a map from the settings screen to view locations on the map.
        </p>

        <div style={styles.buttonContainer}>
          <button
            style={{ ...styles.button, ...styles.secondaryButton }}
            onClick={closeMapSelectionDialogModal}
          >
            Cancel
          </button>

          <button
            style={{ ...styles.button, ...styles.primaryButton }}
            onClick={handleSettingsClick}
          >
            Go to Settings
          </button>
        </div>
      </div>
    </div>
  );
};

MapSelectionDialogModal.propTypes = {
  showMapSelectionModalDialog: PropTypes.any,
  closeMapSelectionDialogModal: PropTypes.any,
  navigateToMapSettingsScreen: PropTypes.any,
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    padding: "0 20px",
  },
  container: {
    backgroundColor: tokens.surface,
    borderRadius: "14px",
    padding: "24px",
    minWidth: "300px",
    maxWidth: "450px",
    boxShadow: tokens.shadowLg,
    textAlign: "center",
  },
  titleText: {
    fontSize: "18px",
    fontWeight: 700,
    color: tokens.text,
    marginTop: 0,
    marginBottom: "12px",
  },
  messageText: {
    fontSize: "14px",
    color: tokens.text2,
    lineHeight: "1.5",
    marginBottom: "24px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "12px",
  },
  button: {
    flex: 1,
    padding: "10px 16px",
    borderRadius: "9px",
    fontSize: "13.5px",
    fontWeight: 600,
    cursor: "pointer",
    border: "none",
    transition: "opacity 0.2s",
  },
  secondaryButton: { backgroundColor: tokens.surface2, color: tokens.text2 },
  primaryButton: { backgroundColor: tokens.accent, color: "#fff", fontWeight: 700 },
};
